export default {
  path: '/v5/matches/pro_series/:id',
  name: 'V5_pro_series',
  component: () => import('./V5ProSeriesPage.vue'),
};
